<div class="min-h-screen bg-neutral-50 text-neutral-800 font-body">

  <main class="text-center py-20 px-6">
    <h2 class="text-4xl font-heading text-primary mb-4">Your Central Hub for HR & Team Operations</h2>
    <p class="text-lg text-neutral-600 mb-6">Manage employee profiles, documents, leave, and timesheets with ease.</p>
    <button class="bg-accent text-white px-6 py-3 rounded-md text-lg shadow">Start Free Trial</button>
  </main>

  <section class="bg-white py-12">
    <div class="container mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 px-4">
      <div>
        <h3 class="text-xl font-semibold text-primary mb-2">👤 Employee Management</h3>
        <p>Centralized employee profile and job tracking system.</p>
      </div>
      <div>
        <h3 class="text-xl font-semibold text-primary mb-2">🗂 Documents & IDs</h3>
        <p>Secure upload and verification of personal and DBS docs.</p>
      </div>
      <div>
        <h3 class="text-xl font-semibold text-primary mb-2">🕒 Timesheets & Leave</h3>
        <p>Track working hours, apply and approve leaves easily.</p>
      </div>
    </div>
  </section>
</div>
